/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const capacityPerformanceEnumsCurrentStatusOptionEnum = {
    Online: 'Online',
    Offline: 'Offline',
    Busy: 'Busy',
    Overwhelmed: 'Overwhelmed',
    Saturated: 'Saturated',
    Other: 'Other',
} as const;

export type CapacityPerformanceEnumsCurrentStatusOptionEnumKey =
    (typeof capacityPerformanceEnumsCurrentStatusOptionEnum)[keyof typeof capacityPerformanceEnumsCurrentStatusOptionEnum];

export type CapacityPerformanceEnumsCurrentStatusOption = CapacityPerformanceEnumsCurrentStatusOptionEnumKey;
